/** Core logging system with pluggable output adapters. */
let adapter = null;
export function setLogAdapter(newAdapter) {
    adapter = newAdapter;
}
export function trace(message, ...args) {
    adapter?.trace(message, ...args);
}
export function debug(message, ...args) {
    adapter?.debug(message, ...args);
}
export function info(message, ...args) {
    adapter?.info(message, ...args);
}
export function warn(message, ...args) {
    adapter?.warn(message, ...args);
}
export function error(message, ...args) {
    adapter?.error(message, ...args);
}
//# sourceMappingURL=logger.js.map